document.addEventListener('click', function(event) {
  const composedPath = event.composedPath();
  
  // ===== WHATSAPP BUTTON (SHADOW DOM) =====
  const whatsappButton = composedPath.find(el => 
    el.tagName === 'GTY-WHATSAPP-CHAT-BUTTON'
  );
  
  if (whatsappButton) {
    const clickedWrapper = composedPath.find(el => 
      el.classList && el.classList.contains('gty-wacb-wrapper')
    );
    
    const clickedButton = composedPath.find(el => 
      el.classList && el.classList.contains('gty-wacb-button')
    );
    
    if (clickedWrapper || clickedButton) {
      sendGoogleAdsConversion();
      return;
    }
  }
  
  // ===== TESTIMONIAL IMAGE =====
  const clickedImg = event.target.closest('img');
  
  if (clickedImg && clickedImg.src && clickedImg.src.includes('Testimonial_LInk.jpg')) {
    sendGoogleAdsConversion();
  }
});

function sendGoogleAdsConversion() {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'conversion', {
      'send_to': 'AW-10945948851/_plJCP2Xtu0bELPZt-Mo'
    });
  }
}